import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import uuid from 'uuid';
import inflateWidget from 'web/components/widgets/inflater';
import PopupBuilderContainer from '../../../containers/PopupBuilderContainer';
import sectionInflater from '../inflater';

const propTypes = {
  presentPage: PropTypes.object,
  revise: PropTypes.func,
  saveVersion: PropTypes.func,
  showPopUpModal: PropTypes.bool.isRequired,
  onClosePopUpModal: PropTypes.func.isRequired,
};

const defaultProps = {
  presentPage: {},
};

const getAddOnsSection = function ({ presentPage: { version } }) {
  return version ? version.sections.find(section => section.type === 'AddOns') : null;
};

const AddOnsEditor = ({
  presentPage,
  revise,
  saveVersion,
  showPopUpModal,
  onClosePopUpModal,
  ...props
}) => {
  const getSavedWidget = (type) => {
    const section = getAddOnsSection({ presentPage });
    return section ? section.widgets.find(widget => widget && widget.type === type) : null;
  };

  const reviseSections = async (sections) => {
    const version = {
      ...presentPage.version,
      sections,
      id: uuid.v4(),
    };

    await revise(version);
    saveVersion(presentPage.id, version);
  };

  const deleteWidget = (widgetType) => {
    const { version: { sections } } = presentPage;
    const section = getAddOnsSection({ presentPage });
    let revisedSections = sections;

    if (section.widgets.length === 1) {
      revisedSections = sections.slice(1);
    } else {
      revisedSections[0].widgets = section.widgets.filter(({ type }) => type !== widgetType);
    }

    reviseSections(revisedSections);
  };

  const saveWidget = (type, payload) => {
    const section = getAddOnsSection({ presentPage }) || sectionInflater('AddOns');
    const widget = inflateWidget([type, payload]);

    if (getSavedWidget(type)) {
      section.widgets.forEach((wdgt, idx) => {
        if (wdgt && wdgt.type === type) section.widgets[idx] = widget;
      });
    } else {
      // Only save widgets that != undefined/null after deletion
      section.widgets = [...section.widgets.filter(wdgt => wdgt), widget];
    }

    const sections = update(presentPage.version.sections, {
      $splice: [
        [0, getAddOnsSection({ presentPage }) ? 1 : 0, section],
      ],
    });

    reviseSections(sections);
  };

  return (
    <div>
      {showPopUpModal &&
        <PopupBuilderContainer
          {...props}
          show={showPopUpModal}
          onClose={onClosePopUpModal}
          save={saveWidget}
          delete={deleteWidget}
          savedWidget={getSavedWidget('PopUp')}
        />
      }
    </div>
  );
};

AddOnsEditor.propTypes = propTypes;
AddOnsEditor.defaultProps = defaultProps;

export default AddOnsEditor;
